<template>
    <div class="tc-project-context-anchor">
        <div class="tc-project-context">
            <div class="tc-project-context-item"
                 @click.stop="$emit('rename')">
                Переименовать
            </div>
            <div class="tc-project-context-item"
                 @click.stop="$emit('copy')">
                Сделать копию
            </div>
            <div class="tc-project-context-item"
                 @click.stop="$emit('delete')">
                Удалить
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'ProjectContext',
    emits: [ 'rename', 'copy', 'delete' ],
};
</script>

<style scoped lang="scss">
.tc-project-context-anchor {
    position: absolute;
    width: 0;
    height: 0;
    display: flex;
    justify-content: flex-end;
}

.tc-project-context {
    position: absolute;
    left: 95px;
    top: 220px;
    width: max-content;
    height: max-content;
    padding: 10px 0;
    box-sizing: border-box;
    display: flex;
    gap: 2px;
    flex-direction: column;
    z-index: 1500;
    background-color: #FFFFFF;
    box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.2);
}

.tc-project-context-item {
    color: #333333;
    height: 28px;
    justify-content: flex-start;
    align-items: center;
    display: flex;
    padding: 0 15px;
    cursor: pointer;
    user-select: none;
    transition: 0.3s ease all;
}

.tc-project-context-item:hover {
    background-color: #F2F2F2;
}

.tc-project-context-item:active {
    color: #00458D;
}
</style>
